import { gql } from '@apollo/client';

export * from './saasEscrows.query.generated';

export const SAAS_ESCROWS = gql`
  query saasEscrows(
    $order: QueryOrderEnum
    $escrowParty: EscrowPartyTypeEnum
    $status: EscrowStatusFilterEnum
    $page: Int
    $perPage: Int
    $query: String
  ) {
    saasEscrows(
      order: $order
      escrowParty: $escrowParty
      status: $status
      page: $page
      perPage: $perPage
      query: $query
    ) {
      nodes {
        ...SaasEscrowBaseFields
      }
      nodesCount
      pagesCount
    }
  }
`;
